import React, { createContext, useContext } from "react";
import { translations } from "../i18n";

const LanguageContext = createContext(null);

/**
 * Trellure is English-only for now.
 *
 * This stays as a provider rather than a bare import so copy keeps flowing
 * through one lookup: adding a locale later means restoring the selector here,
 * not hunting literals back out of the components.
 */
export function LanguageProvider({ children }) {
  const t = (key) => translations.en[key] || key;
  return <LanguageContext.Provider value={{ t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
